console.log('process.env',process.env)
const serverList = [
  {
    BASEURL: 'http://192.168.68.100:8304',
  },
  {
    BASEURL: 'https://game.daoyigame.com/api',
  }
];
let serverArr = serverList[1]
export default serverArr
